$(document).ready(function () {

    if (window.matchMedia('(max-width: 1023px)').matches) {
        $(document).on('click', 'li[data-main-menu] .icon', function (event) {
            event.preventDefault()
            var thisElement = $(this).closest('li')
            var menuHandle = $(this).closest('li').data('main-menu')
            $(document)
                .find('[data-submenu]')
                .each(function () {
                    var subHandle = $(this).data('submenu')
                    if (subHandle === menuHandle) {
                        if ($(this).hasClass('item-active')) {
                            $(this).slideUp().removeClass('item-active')
                            thisElement.removeClass('item-active')
                        } else {
                            thisElement.addClass('item-active')
                            $(this).slideDown().addClass('item-active')
                        }
                    }
                })
            return false
        })
    } else {
        $('.itg-left-menu').hover(function () {
            var thisHandle = $(this).data('handle')
            var parentDiv = $(this).parent('#custom-mega-menu')
            parentDiv.find('.itg-left-menu').removeClass('active')
            $(this).addClass('active')
            var thisElement = $(this)
            parentDiv.find('.babymenu-drop').each(function () {
                var dropHandle = $(this).data('handle')
                if (dropHandle == thisHandle) {
                    $(this).addClass('active')
                } else {
                    $(this).removeClass('active')
                }
            })
        })
    }

   const checkAvailITG = () => {

    var deliverySuccess = $(document).find('body').data('delivery-success')
    var deliveryError = $(document).find('body').data('delivery-error')

    if (
        $(document).find('[data-shipping-id]').length ||
        $(document).find('[data-shipping-item-id]').length
    ) {
        var variantArray = []
        $(document)
            .find('[data-shipping-id]')
            .each(function () {
                var variantId = $(this).data('shipping-id')
                variantArray.push(variantId)
            })
        $(document)
            .find('[data-shipping-item-id]')
            .each(function () {
                var variantId = $(this).data('shipping-item-id')
                variantArray.push(variantId)
            })

        if (
            variantArray.length > 0 &&
            $(document).find('.shipping-available-location-name').length
        ) {
            var shippingFromLocation = $(document)
                .find('.shipping-available-location-name')
                .data('location-name')
                .toString()
            var checkFinalArray = []
            Shopify.shipping = variantArray
            Shopify.shippingAlong = function () {

                if (Shopify.shipping.length) {
                    var variantId = Shopify.shipping.shift()
                    var checkFinalArrayInner = {}

                    const variantSectionUrl =
                        '/variants/' +
                        variantId +
                        '/?section_id=helper-pickup-availability-extended'

                    fetch(variantSectionUrl)
                        .then((response) => response.text())
                        .then((text) => {
                            const sectionInnerHTML = new DOMParser()
                                .parseFromString(text, 'text/html')
                                .querySelector('.shopify-section')
                            var variantId = $(sectionInnerHTML)
                                .find('#variant-availability')
                                .data('variant-id')
                            var variantLocationAvailability = $(
                                sectionInnerHTML
                            )
                                .find('#variant-availability')
                                .data('location')
                                .toString()

                            checkFinalArrayInner['variant-id'] = variantId
                            var checkQty = 'false'
                            if (shippingFromLocation.indexOf(',') != -1) {
                                var splitLocation =
                                    shippingFromLocation.split(',')
                                splitLocation.forEach(function (locationName) {
                                    if (
                                        variantLocationAvailability.indexOf(
                                            locationName
                                        ) != -1
                                    ) {
                                        checkQty = 'true'
                                    }
                                })
                            } else {
                                if (
                                    variantLocationAvailability.indexOf(
                                        shippingFromLocation
                                    ) != -1
                                ) {
                                    checkQty = 'true'
                                }
                            }
                            checkFinalArrayInner['available'] = checkQty
                            checkFinalArray.push(checkFinalArrayInner)
                            Shopify.shippingAlong()
                        })
                } else {
                    var convertFinalArrayStringify =
                        JSON.stringify(checkFinalArray)
                    $(document)
                        .find('body')
                        .append(
                            '<script id="itg-shipping-availability">' +
                                convertFinalArrayStringify +
                                '</script>'
                        )
                    $(document)
                        .find('[data-shipping-id]')
                        .each(function () {
                            var thisVariantId = $(this).data('shipping-id')
                            var thisElement = $(this)
                            var thisDrawer = $(this).data('drawer')
                            checkFinalArray.forEach(function (variantData) {
                                if (
                                    thisVariantId === variantData['variant-id']
                                ) {
                                    if (variantData['available'] === 'true') {
                                        if (thisDrawer === true) {
                                            thisElement
                                                .removeClass(
                                                    'alert--circle-loading alert--note alert--error unavailable-delivery'
                                                )
                                                .addClass('alert--success')
                                        } else {
                                            thisElement
                                                .removeClass(
                                                    'alert--circle-loading alert--note alert--error unavailable-delivery'
                                                )
                                                .addClass('alert--success')
                                                .text(deliverySuccess)
                                        }
                                    } else {
                                        if (thisDrawer === true) {
                                            thisElement
                                                .removeClass(
                                                    'alert--circle-loading alert--note alert--success'
                                                )
                                                .addClass(
                                                    'alert--error unavailable-delivery'
                                                )
                                        } else {
                                            thisElement
                                                .removeClass(
                                                    'alert--circle-loading alert--note alert--success'
                                                )
                                                .addClass(
                                                    'alert--error unavailable-delivery'
                                                )
                                                .text(deliveryError)
                                        }
                                    }
                                }
                            })
                        })
                }
            }
            Shopify.shippingAlong()
        }
    }

    if (
        $(document).find('[data-list-shipping-id]').length &&
        $(document).find('.shipping-available-location-name').length
    ) {
        var shippingFromLocation = $(document)
            .find('.shipping-available-location-name')
            .data('location-name')
            .toString()
        var variantItemsArray = []
        $(document)
            .find('[data-list-shipping-id]')
            .each(function (index) {
                var variantId = $(this).data('list-shipping-id')
                var productId = $(this).data('product-id')
                variantItemsArray[index] = []
                variantItemsArray[index]['product-id'] = productId
                variantItemsArray[index]['variant-id'] = variantId
            })
        if (variantItemsArray.length > 0) {
            Shopify.queue = []
            for (var i = 0; i < variantItemsArray.length; i++) {
                product = variantItemsArray[i]['product-id']
                variant = variantItemsArray[i]['variant-id']
                Shopify.queue.push({
                    productId: product,
                    variantId: variant,
                })
            }
        }
        Shopify.moveAlong = function () {
            if (Shopify.queue.length) {
                var request = Shopify.queue.shift()
                var dataproductId = request.productId
                var dataVariantId = request.variantId.toString()
                if (dataVariantId.indexOf(',') != -1) {
                    Shopify.queueInner = []
                    var newArray = dataVariantId.split(',')
                    for (var i = 0; i < newArray.length; i++) {
                        Shopify.queueInner.push({
                            variantId: newArray[i],
                        })
                    }
                    var counterCheckQty = 'false'
                    Shopify.moveInnerAlong = function () {
                        if (Shopify.queueInner.length) {
                            var request = Shopify.queueInner.shift()
                            var dataVariant = request.variantId
                            const variantSectionUrl =
                                '/variants/' +
                                dataVariant +
                                '/?section_id=helper-pickup-availability-extended'
                            fetch(variantSectionUrl)
                                .then((response) => response.text())
                                .then((text) => {
                                    var checkFinalArray = []
                                    var checkFinalArrayInner = {}
                                    const sectionInnerHTML = new DOMParser()
                                        .parseFromString(text, 'text/html')
                                        .querySelector('.shopify-section')
                                    var variantId = $(sectionInnerHTML)
                                        .find('#variant-availability')
                                        .data('variant-id')
                                    var variantLocationAvailability = $(
                                        sectionInnerHTML
                                    )
                                        .find('#variant-availability')
                                        .data('location')
                                        .toString()
                                    checkFinalArrayInner['variant-id'] =
                                        variantId
                                    var checkQty = 'false'
                                    if (
                                        shippingFromLocation.indexOf(',') != -1
                                    ) {
                                        var splitLocation =
                                            shippingFromLocation.split(',')
                                        splitLocation.forEach(
                                            function (locationName) {
                                                if (
                                                    variantLocationAvailability.indexOf(
                                                        locationName
                                                    ) != -1
                                                ) {
                                                    checkQty = 'true'
                                                    counterCheckQty = 'true'
                                                }
                                            }
                                        )
                                    } else {
                                        if (
                                            variantLocationAvailability.indexOf(
                                                shippingFromLocation
                                            ) != -1
                                        ) {
                                            checkQty = 'true'
                                            counterCheckQty = 'true'
                                        }
                                    }
                                    checkFinalArrayInner['available'] = checkQty
                                    checkFinalArray.push(checkFinalArrayInner)
                                    if (
                                        $(document).find(
                                            '#itg-item-shipping-availability'
                                        ).length
                                    ) {
                                        var getItemScript = $(document)
                                            .find(
                                                '#itg-item-shipping-availability'
                                            )
                                            .html()
                                        var getFinalArray =
                                            JSON.parse(getItemScript)
                                        var finalArrayLength =
                                            getFinalArray.length
                                        finalArrayLength = finalArrayLength - 1
                                        checkFinalArray.forEach(
                                            function (variantData) {
                                                finalArrayLength =
                                                    finalArrayLength + 1
                                                getFinalArray[
                                                    finalArrayLength
                                                ] = {}
                                                getFinalArray[finalArrayLength][
                                                    'variant-id'
                                                ] = variantData['variant-id']
                                                getFinalArray[finalArrayLength][
                                                    'available'
                                                ] = variantData['available']
                                            }
                                        )
                                        var convertFinalArrayStringify =
                                            JSON.stringify(getFinalArray)
                                        $(document)
                                            .find(
                                                '#itg-item-shipping-availability'
                                            )
                                            .empty()
                                            .append(convertFinalArrayStringify)
                                    } else {
                                        var convertFinalArrayStringify =
                                            JSON.stringify(checkFinalArray)
                                        $(document)
                                            .find('body')
                                            .append(
                                                '<script id="itg-item-shipping-availability">' +
                                                    convertFinalArrayStringify +
                                                    '</script>'
                                            )
                                    }
                                    Shopify.moveInnerAlong()
                                })
                        } else {
                            if (counterCheckQty == 'true') {
                                $(document)
                                    .find(
                                        'span[data-product-id="' +
                                            dataproductId +
                                            '"]'
                                    )
                                    .removeClass(
                                        'alert--circle-loading alert--note alert--error unavailable-delivery'
                                    )
                                    .addClass('alert--success')
                                    .text(deliverySuccess)
                            } else {
                                $(document)
                                    .find(
                                        'span[data-product-id="' +
                                            dataproductId +
                                            '"]'
                                    )
                                    .removeClass(
                                        'alert--circle-loading alert--note alert--success'
                                    )
                                    .addClass(
                                        'alert--error unavailable-delivery'
                                    )
                                    .text(deliveryError)
                            }
                            counterCheckQty = 'false'
                            Shopify.moveAlong()
                        }
                    }
                    Shopify.moveInnerAlong()
                } else {
                    const variantSectionUrl =
                        '/variants/' +
                        dataVariantId +
                        '/?section_id=helper-pickup-availability-extended'
                    fetch(variantSectionUrl)
                        .then((response) => response.text())
                        .then((text) => {
                            var checkFinalArray = []
                            var checkFinalArrayInner = {}
                            const sectionInnerHTML = new DOMParser()
                                .parseFromString(text, 'text/html')
                                .querySelector('.shopify-section')
                            var variantId = $(sectionInnerHTML)
                                .find('#variant-availability')
                                .data('variant-id')
                            var variantLocationAvailability = $(
                                sectionInnerHTML
                            )
                                .find('#variant-availability')
                                .data('location')
                                .toString()
                            checkFinalArrayInner['variant-id'] = variantId
                            var checkQty = 'false'
                            if (shippingFromLocation.indexOf(',') != -1) {
                                var splitLocation =
                                    shippingFromLocation.split(',')
                                splitLocation.forEach(function (locationName) {
                                    if (
                                        variantLocationAvailability.indexOf(
                                            locationName
                                        ) != -1
                                    ) {
                                        checkQty = 'true'
                                    }
                                })
                            } else {
                                if (
                                    variantLocationAvailability.indexOf(
                                        shippingFromLocation
                                    ) != -1
                                ) {
                                    checkQty = 'true'
                                }
                            }
                            checkFinalArrayInner['available'] = checkQty
                            checkFinalArray.push(checkFinalArrayInner)
                            if (
                                $(document).find(
                                    '#itg-item-shipping-availability'
                                ).length
                            ) {
                                var getItemScript = $(document)
                                    .find('#itg-item-shipping-availability')
                                    .html()
                                var getFinalArray = JSON.parse(getItemScript)
                                var finalArrayLength = getFinalArray.length
                                finalArrayLength = finalArrayLength - 1
                                checkFinalArray.forEach(function (variantData) {
                                    finalArrayLength = finalArrayLength + 1
                                    getFinalArray[finalArrayLength] = {}
                                    getFinalArray[finalArrayLength][
                                        'variant-id'
                                    ] = variantData['variant-id']
                                    getFinalArray[finalArrayLength][
                                        'available'
                                    ] = variantData['available']
                                })
                                var convertFinalArrayStringify =
                                    JSON.stringify(getFinalArray)
                                $(document)
                                    .find('#itg-item-shipping-availability')
                                    .empty()
                                    .append(convertFinalArrayStringify)
                            } else {
                                var convertFinalArrayStringify =
                                    JSON.stringify(checkFinalArray)
                                $(document)
                                    .find('body')
                                    .append(
                                        '<script id="itg-item-shipping-availability">' +
                                            convertFinalArrayStringify +
                                            '</script>'
                                    )
                            }
                           
                            if (checkQty == 'true') {
                                $(document)
                                    .find(
                                        'span[data-product-id="' +
                                            dataproductId +
                                            '"]'
                                    )
                                    .removeClass(
                                        'alert--circle-loading alert--note alert--error unavailable-delivery'
                                    )
                                    .addClass('alert--success')
                                    .text(deliverySuccess)
                            } else {
                                $(document)
                                    .find(
                                        'span[data-product-id="' +
                                            dataproductId +
                                            '"]'
                                    )
                                    .removeClass(
                                        'alert--circle-loading alert--note alert--success'
                                    )
                                    .addClass(
                                        'alert--error unavailable-delivery'
                                    )
                                    .text(deliveryError)
                            }
                            Shopify.moveAlong()
                        })
                }
            }
        }
        Shopify.moveAlong()
    }


}

checkAvailITG();
});
setInterval(function () {
    $(document)
        .find('.product-item__text,.product-text')
        .removeClass('disable-addbtn')
    $(document)
        .find('.shipping-indicator-card')
        .find('.unavailable-delivery')
        .each(function () {
            var checkAvaileblity = $(this)
                .next('pickup-availability-compact')
                .find('#change-store')
                .data('available')
            if (checkAvaileblity == false) {
                $(this)
                    .parents('.product-item__text')
                    .addClass('disable-addbtn')
            } else {
                $(this)
                    .parents('.product-item__text')
                    .removeClass('disable-addbtn')
            }
        })
    $(document)
        .find('.itg-ship-pickup')
        .find('.unavailable-delivery')
        .each(function () {
            var checkAvaileblity = $(this)
                .next('pickup-availability-compact')
                .find('#change-store')
                .data('available')
            if (checkAvaileblity == false) {
                $(this).parents('.product-text').addClass('disable-addbtn')
            } else {
                $(this).parents('.product-text').removeClass('disable-addbtn')
            }
        })
}, 1000)

$(document).on('click', '#change-store', function () {
    $(document).find('#site-store-selector-handle').trigger('click')
})


document.addEventListener("rebuy.init", function(event) {
  return ;

    if($(document).find('body').hasClass("RunningItg")) { 
        return false;
    }

    $(document).find('body').addClass("RunningItg");
    setTimeout(()=>{

  document.querySelectorAll(".rebuy-product-block").forEach((card) => {
    const linkEl = card.querySelector(".rebuy-product-media a");
    if (!linkEl) return;

  const productLink = linkEl.getAttribute("href");

  // Insert placeholder into each card
  card.insertAdjacentHTML("beforeend", `<div class="card-availability"></div>`);
  const availabilityContainer = card.querySelector(".card-availability");

  // Fetch PDP HTML
  fetch(productLink)
    .then((res) => res.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Find your pickup element
      const pickupEl = doc.querySelector(".itgGetPickupElement");

      if (pickupEl) {
        // Append its innerHTML into the card
        availabilityContainer.innerHTML = pickupEl.innerHTML;
            console.log("Done");
    $(document).find('body').removeClass("RunningItg");

      } else {
        availabilityContainer.innerHTML = `<span class="alert alert--note">Pickup info not found</span>`;
      }
    })
    .catch((err) => console.error("Fetch error:", err));
});

},200)

 setTimeout(() => {

    var deliverySuccess = $(document).find('body').data('delivery-success')
    var deliveryError = $(document).find('body').data('delivery-error')
    return false;
    if (
        $(document).find('[data-shipping-id]').length ||
        $(document).find('[data-shipping-item-id]').length
    ) {
        var variantArray = []
        $(document)
            .find('[data-shipping-id]')
            .each(function () {
                var variantId = $(this).data('shipping-id')
                variantArray.push(variantId)
            })
        $(document)
            .find('[data-shipping-item-id]')
            .each(function () {
                var variantId = $(this).data('shipping-item-id')
                variantArray.push(variantId)
            })


        if (
            variantArray.length > 0 &&
            $(document).find('.shipping-available-location-name').length
        ) {
            var shippingFromLocation = $(document)
                .find('.shipping-available-location-name')
                .data('location-name')
                .toString()
            var checkFinalArray = []
            Shopify.shipping = variantArray
            Shopify.shippingAlong = function () {

                if (Shopify.shipping.length) {

                    var variantId = Shopify.shipping.shift()
                    var checkFinalArrayInner = {}

                    const variantSectionUrl =
                        '/variants/' +
                        variantId +
                        '/?section_id=helper-pickup-availability-extended'

                    fetch(variantSectionUrl)
                        .then((response) => response.text())
                        .then((text) => {
                            const sectionInnerHTML = new DOMParser()
                                .parseFromString(text, 'text/html')
                                .querySelector('.shopify-section')
                            var variantId = $(sectionInnerHTML)
                                .find('#variant-availability')
                                .data('variant-id')
                            var variantLocationAvailability = $(
                                sectionInnerHTML
                            )
                                .find('#variant-availability')
                                .data('location')
                                .toString()

                            checkFinalArrayInner['variant-id'] = variantId
                            var checkQty = 'false'
                            if (shippingFromLocation.indexOf(',') != -1) {
                                var splitLocation =
                                    shippingFromLocation.split(',')
                                splitLocation.forEach(function (locationName) {
                                    if (
                                        variantLocationAvailability.indexOf(
                                            locationName
                                        ) != -1
                                    ) {
                                        checkQty = 'true'
                                    }
                                })
                            } else {
                                if (
                                    variantLocationAvailability.indexOf(
                                        shippingFromLocation
                                    ) != -1
                                ) {
                                    checkQty = 'true'
                                }
                            }
                            checkFinalArrayInner['available'] = checkQty
                            checkFinalArray.push(checkFinalArrayInner)
                            Shopify.shippingAlong()
                        })
                } else {
                    var convertFinalArrayStringify =
                        JSON.stringify(checkFinalArray)
                    $(document)
                        .find('body')
                        .append(
                            '<script id="itg-shipping-availability">' +
                                convertFinalArrayStringify +
                                '</script>'
                        )
                    $(document)
                        .find('[data-shipping-id]')
                        .each(function () {
                            var thisVariantId = $(this).data('shipping-id')
                            var thisElement = $(this)
                            var thisDrawer = $(this).data('drawer')
                            checkFinalArray.forEach(function (variantData) {
                                if (
                                    thisVariantId === variantData['variant-id']
                                ) {
                                    if (variantData['available'] === 'true') {
                                        if (thisDrawer === true) {
                                            thisElement
                                                .removeClass(
                                                    'alert--circle-loading alert--note alert--error unavailable-delivery'
                                                )
                                                .addClass('alert--success')
                                        } else {
                                            thisElement
                                                .removeClass(
                                                    'alert--circle-loading alert--note alert--error unavailable-delivery'
                                                )
                                                .addClass('alert--success')
                                                .text(deliverySuccess)
                                        }
                                    } else {
                                        if (thisDrawer === true) {
                                            thisElement
                                                .removeClass(
                                                    'alert--circle-loading alert--note alert--success'
                                                )
                                                .addClass(
                                                    'alert--error unavailable-delivery'
                                                )
                                        } else {
                                            thisElement
                                                .removeClass(
                                                    'alert--circle-loading alert--note alert--success'
                                                )
                                                .addClass(
                                                    'alert--error unavailable-delivery'
                                                )
                                                .text(deliveryError)
                                        }
                                    }
                                }
                            })
                        })
                }
            }
            Shopify.shippingAlong()
        }
    }

    if (
        $(document).find('[data-list-shipping-id]').length &&
        $(document).find('.shipping-available-location-name').length
    ) {
        var shippingFromLocation = $(document)
            .find('.shipping-available-location-name')
            .data('location-name')
            .toString()
        var variantItemsArray = []
        $(document)
            .find('[data-list-shipping-id]')
            .each(function (index) {
                var variantId = $(this).data('list-shipping-id')
                var productId = $(this).data('product-id')
                variantItemsArray[index] = []
                variantItemsArray[index]['product-id'] = productId
                variantItemsArray[index]['variant-id'] = variantId
            })
        if (variantItemsArray.length > 0) {
            Shopify.queue = []
            for (var i = 0; i < variantItemsArray.length; i++) {
                product = variantItemsArray[i]['product-id']
                variant = variantItemsArray[i]['variant-id']
                Shopify.queue.push({
                    productId: product,
                    variantId: variant,
                })
            }
        }
        Shopify.moveAlong = function () {
            if (Shopify.queue.length) {
                var request = Shopify.queue.shift()
                var dataproductId = request.productId
                var dataVariantId = request.variantId.toString()
                if (dataVariantId.indexOf(',') != -1) {
                    Shopify.queueInner = []
                    var newArray = dataVariantId.split(',')
                    for (var i = 0; i < newArray.length; i++) {
                        Shopify.queueInner.push({
                            variantId: newArray[i],
                        })
                    }
                    var counterCheckQty = 'false'
                    Shopify.moveInnerAlong = function () {
                        if (Shopify.queueInner.length) {
                            var request = Shopify.queueInner.shift()
                            var dataVariant = request.variantId
                            const variantSectionUrl =
                                '/variants/' +
                                dataVariant +
                                '/?section_id=helper-pickup-availability-extended'
                            fetch(variantSectionUrl)
                                .then((response) => response.text())
                                .then((text) => {
                                    var checkFinalArray = []
                                    var checkFinalArrayInner = {}
                                    const sectionInnerHTML = new DOMParser()
                                        .parseFromString(text, 'text/html')
                                        .querySelector('.shopify-section')
                                    var variantId = $(sectionInnerHTML)
                                        .find('#variant-availability')
                                        .data('variant-id')
                                    var variantLocationAvailability = $(
                                        sectionInnerHTML
                                    )
                                        .find('#variant-availability')
                                        .data('location')
                                        .toString()
                                    checkFinalArrayInner['variant-id'] =
                                        variantId
                                    var checkQty = 'false'
                                    if (
                                        shippingFromLocation.indexOf(',') != -1
                                    ) {
                                        var splitLocation =
                                            shippingFromLocation.split(',')
                                        splitLocation.forEach(
                                            function (locationName) {
                                                if (
                                                    variantLocationAvailability.indexOf(
                                                        locationName
                                                    ) != -1
                                                ) {
                                                    checkQty = 'true'
                                                    counterCheckQty = 'true'
                                                }
                                            }
                                        )
                                    } else {
                                        if (
                                            variantLocationAvailability.indexOf(
                                                shippingFromLocation
                                            ) != -1
                                        ) {
                                            checkQty = 'true'
                                            counterCheckQty = 'true'
                                        }
                                    }
                                    checkFinalArrayInner['available'] = checkQty
                                    checkFinalArray.push(checkFinalArrayInner)
                                    if (
                                        $(document).find(
                                            '#itg-item-shipping-availability'
                                        ).length
                                    ) {
                                        var getItemScript = $(document)
                                            .find(
                                                '#itg-item-shipping-availability'
                                            )
                                            .html()
                                        var getFinalArray =
                                            JSON.parse(getItemScript)
                                        var finalArrayLength =
                                            getFinalArray.length
                                        finalArrayLength = finalArrayLength - 1
                                        checkFinalArray.forEach(
                                            function (variantData) {
                                                finalArrayLength =
                                                    finalArrayLength + 1
                                                getFinalArray[
                                                    finalArrayLength
                                                ] = {}
                                                getFinalArray[finalArrayLength][
                                                    'variant-id'
                                                ] = variantData['variant-id']
                                                getFinalArray[finalArrayLength][
                                                    'available'
                                                ] = variantData['available']
                                            }
                                        )
                                        var convertFinalArrayStringify =
                                            JSON.stringify(getFinalArray)
                                        $(document)
                                            .find(
                                                '#itg-item-shipping-availability'
                                            )
                                            .empty()
                                            .append(convertFinalArrayStringify)
                                    } else {
                                        var convertFinalArrayStringify =
                                            JSON.stringify(checkFinalArray)
                                        $(document)
                                            .find('body')
                                            .append(
                                                '<script id="itg-item-shipping-availability">' +
                                                    convertFinalArrayStringify +
                                                    '</script>'
                                            )
                                    }
                                    Shopify.moveInnerAlong()
                                })
                        } else {
                            if (counterCheckQty == 'true') {
                                $(document)
                                    .find(
                                        'span[data-product-id="' +
                                            dataproductId +
                                            '"]'
                                    )
                                    .removeClass(
                                        'alert--circle-loading alert--note alert--error unavailable-delivery'
                                    )
                                    .addClass('alert--success')
                                    .text(deliverySuccess)
                            } else {
                                $(document)
                                    .find(
                                        'span[data-product-id="' +
                                            dataproductId +
                                            '"]'
                                    )
                                    .removeClass(
                                        'alert--circle-loading alert--note alert--success'
                                    )
                                    .addClass(
                                        'alert--error unavailable-delivery'
                                    )
                                    .text(deliveryError)
                            }
                            counterCheckQty = 'false'
                            Shopify.moveAlong()
                        }
                    }
                    Shopify.moveInnerAlong()
                } else {
                    const variantSectionUrl =
                        '/variants/' +
                        dataVariantId +
                        '/?section_id=helper-pickup-availability-extended'
                    fetch(variantSectionUrl)
                        .then((response) => response.text())
                        .then((text) => {
                            var checkFinalArray = []
                            var checkFinalArrayInner = {}
                            const sectionInnerHTML = new DOMParser()
                                .parseFromString(text, 'text/html')
                                .querySelector('.shopify-section')
                            var variantId = $(sectionInnerHTML)
                                .find('#variant-availability')
                                .data('variant-id')
                            var variantLocationAvailability = $(
                                sectionInnerHTML
                            )
                                .find('#variant-availability')
                                .data('location')
                                .toString()
                            checkFinalArrayInner['variant-id'] = variantId
                            var checkQty = 'false'
                            if (shippingFromLocation.indexOf(',') != -1) {
                                var splitLocation =
                                    shippingFromLocation.split(',')
                                splitLocation.forEach(function (locationName) {
                                    if (
                                        variantLocationAvailability.indexOf(
                                            locationName
                                        ) != -1
                                    ) {
                                        checkQty = 'true'
                                    }
                                })
                            } else {
                                if (
                                    variantLocationAvailability.indexOf(
                                        shippingFromLocation
                                    ) != -1
                                ) {
                                    checkQty = 'true'
                                }
                            }
                            checkFinalArrayInner['available'] = checkQty
                            checkFinalArray.push(checkFinalArrayInner)
                            if (
                                $(document).find(
                                    '#itg-item-shipping-availability'
                                ).length
                            ) {
                                var getItemScript = $(document)
                                    .find('#itg-item-shipping-availability')
                                    .html()
                                var getFinalArray = JSON.parse(getItemScript)
                                var finalArrayLength = getFinalArray.length
                                finalArrayLength = finalArrayLength - 1
                                checkFinalArray.forEach(function (variantData) {
                                    finalArrayLength = finalArrayLength + 1
                                    getFinalArray[finalArrayLength] = {}
                                    getFinalArray[finalArrayLength][
                                        'variant-id'
                                    ] = variantData['variant-id']
                                    getFinalArray[finalArrayLength][
                                        'available'
                                    ] = variantData['available']
                                })
                                var convertFinalArrayStringify =
                                    JSON.stringify(getFinalArray)
                                $(document)
                                    .find('#itg-item-shipping-availability')
                                    .empty()
                                    .append(convertFinalArrayStringify)
                            } else {
                                var convertFinalArrayStringify =
                                    JSON.stringify(checkFinalArray)
                                $(document)
                                    .find('body')
                                    .append(
                                        '<script id="itg-item-shipping-availability">' +
                                            convertFinalArrayStringify +
                                            '</script>'
                                    )
                            }
                           
                            if (checkQty == 'true') {
                                $(document)
                                    .find(
                                        'span[data-product-id="' +
                                            dataproductId +
                                            '"]'
                                    )
                                    .removeClass(
                                        'alert--circle-loading alert--note alert--error unavailable-delivery'
                                    )
                                    .addClass('alert--success')
                                    .text(deliverySuccess)
                            } else {
                                $(document)
                                    .find(
                                        'span[data-product-id="' +
                                            dataproductId +
                                            '"]'
                                    )
                                    .removeClass(
                                        'alert--circle-loading alert--note alert--success'
                                    )
                                    .addClass(
                                        'alert--error unavailable-delivery'
                                    )
                                    .text(deliveryError)
                            }
                            Shopify.moveAlong()
                        })
                }
            }
        }
        Shopify.moveAlong()
    }

    $(document).find('body').removeClass("RunningItg");
}, 15000);

});

// Cart Drawer Progress Bar js

document.addEventListener("DOMContentLoaded", updateProgressBar);

function updateProgressBar() {
    let main_progress_wrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
    if (!main_progress_wrapper) return;

    let cartBar = main_progress_wrapper.querySelector(".cart_drawer_progress_bar");
    let maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
    let cartPrice = parseFloat(cartBar.getAttribute("data-cart-price"));

    localStorage.setItem('loadedCartPrice', cartPrice);

    let allSteps = main_progress_wrapper.querySelectorAll(".progbar_counter");

    // Step markers
    allSteps.forEach(step => {
        let stepAmount = parseFloat(step.getAttribute("data-amount"));
        if (!isNaN(stepAmount) && maxAmountPrice > 0) {
        let percent = Math.round((stepAmount / maxAmountPrice) * 100);
        step.style.left = percent + "%";
        }
    });

    // Filled bar
    if (!isNaN(cartPrice) && maxAmountPrice > 0) {

        let filledPercent = ((cartPrice * 100) / maxAmountPrice);
        filledPercent = Math.min(Math.max(filledPercent, 0), 100);

        let filledBar = cartBar.querySelector(".cart_drawer_filled_bar");
        if (filledBar) {
        filledBar.style.width = filledPercent + "%";
        }
    }    
}

document.addEventListener('click', async (event) => {
    const btn = event.target.closest('.add-to-cart-btn');
    if (!btn) return; // Exit if it's not the button

    event.preventDefault(); // Prevent default behavior only for the button

    // Get variant ID from form input
    const formInput = btn.closest('.itgProduct-card__form')?.querySelector('input[name="id"]');
    if (!formInput) return;

    const variantId = formInput.getAttribute('value');
    if (!variantId) return;

    // Add product to cart
    await addProductToCart(variantId, 1);

    // Remove only the single product wrapper
    const productWrapper = btn.closest('.single_step_product_wrapper');
    if (productWrapper) productWrapper.remove();

    // If no more products remain, remove the entire Free Products accordion
    const accordion = btn.closest('.main_free_product_accordion_wrapper');
    if (accordion && accordion.querySelectorAll('.single_step_product_wrapper').length === 0) {
        accordion.remove();
    }
});


    function newUpdateCartDrawer(){

        	let storedCartPrice = parseFloat(localStorage.getItem('loadedCartPrice')) || 0;

                        let estimateShippingBtn = document.querySelector('.js-estimate-shipping');
                        const cartWrapper = document.querySelector('#site-cart-sidebar .cart-form');
                        const mainCartWrapper = document.querySelector('.template-cart .cart-section');

                        const checkEligibilityInLocalStorage = () => {
                            const eligibility = localStorage.getItem('eligibility');
                            return eligibility?.toLowerCase() === 'true' ? true
                                : eligibility?.toLowerCase() === 'false' ? false
                                : null;
                        };                    

                        const toggleAssemblyInCart = (isEligible) => {

                            if (cartWrapper) cartWrapper.classList.toggle('hide_assembly_variants', !isEligible);
                            if (mainCartWrapper) mainCartWrapper.classList.toggle('hide_assembly_variants', !isEligible);

                            // Get main wrappers (safely)
                            const mainCartDrawerWrapper = cartWrapper?.querySelector(".cart__items");
                            const mainCartPageWrapper = mainCartWrapper?.querySelector(".cart-form__items");

                            let hasAssemblyMessage = false;

                            // --- Process main cart page items ---
                            if (mainCartPageWrapper) {
                                const itemWrappers = mainCartPageWrapper.querySelectorAll('.cart-form-item');

                                itemWrappers.forEach(wrapper => {
                                    const title = (wrapper.dataset.title || "").toLowerCase();

                                    if (title.includes("assembly services")) {
                                        if (!isEligible) {
                                            if (!wrapper.querySelector('.assembly-service-msg')) {
                                                const msg = document.createElement('p');
                                                msg.className = 'assembly-service-msg';
                                                msg.textContent = "Assembly service isn’t offered in your selected location. To proceed with checkout, please remove this item from your cart.";
                                                wrapper.appendChild(msg);
                                            }
                                            hasAssemblyMessage = true;
                                        } else {
                                            const existingMsg = wrapper.querySelector('.assembly-service-msg');
                                            if (existingMsg) existingMsg.remove();
                                        }
                                    }
                                });
                            }

                            // --- Process cart drawer items ---
                            if (mainCartDrawerWrapper) {
                                const itemWrappers = mainCartDrawerWrapper.querySelectorAll('.itg_cart_item_wrapper');

                                itemWrappers.forEach(wrapper => {
                                    const cartItem = wrapper.querySelector('.cart-item');
                                    if (!cartItem) return;

                                    const title = (cartItem.dataset.title || "").toLowerCase();

                                    if (title.includes("assembly services")) {
                                        if (!isEligible) {
                                            if (!wrapper.querySelector('.assembly-service-msg')) {
                                                const msg = document.createElement('p');
                                                msg.className = 'assembly-service-msg';
                                                // msg.textContent = "It is no longer valid for the updated location";
                                                msg.textContent = "Assembly service isn’t offered in your selected location. To proceed with checkout, please remove this item from your cart.";
                                                wrapper.appendChild(msg);
                                            }
                                            hasAssemblyMessage = true;
                                        } else {
                                            const existingMsg = wrapper.querySelector('.assembly-service-msg');
                                            if (existingMsg) existingMsg.remove();
                                        }
                                    }
                                });
                            }

                            // --- Disable all checkout buttons if needed ---
                            const checkoutBtns = document.querySelectorAll('button#CheckOut');
                            checkoutBtns.forEach(btn => {
                                btn.disabled = hasAssemblyMessage;
                                btn.style.opacity = hasAssemblyMessage ? 0.5 : 1;
                                btn.style.pointerEvents = hasAssemblyMessage ? 'none' : 'auto';
                            });
                        };

                        setTimeout(() => {
                            toggleAssemblyInCart(checkEligibilityInLocalStorage());
                        }, 500);
                        
						const subTotalElem = document.getElementById('AjaxCartSubtotal');
						if (!subTotalElem) return;

						let subTotalAmt = subTotalElem.querySelector('.cart__total')?.getAttribute("data-total-price");
						if (!subTotalAmt) return;

					
						let cartPrice = parseFloat(subTotalAmt.replace(/,/g, '').trim());

						const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
						if (!mainProgressWrapper) return;

						const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
						if (!cartBar) return;

						const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
						if (isNaN(maxAmountPrice) || maxAmountPrice <= 0) return;

						const allSteps = mainProgressWrapper.querySelectorAll(".progbar_counter");

						(async () => {
							// Fetch current cart
							const cartResponse = await fetch('/cart.js');
							const cart = await cartResponse.json();

							let allProductsHTML = '';

							const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
							if (!mainProgressWrapper) return;

							const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
							if (!cartBar) return;

							const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
							const subTotalElem = document.getElementById('AjaxCartSubtotal')?.querySelector('.cart__total');
							const cartPrice = parseFloat(subTotalElem?.getAttribute("data-total-price")?.replace(/,/g, '').trim() || 0);

							const allSteps = mainProgressWrapper.querySelectorAll(".progbar_counter");
							if (!allSteps.length) return;

                            allSteps.forEach((step, index) => {
								const stepAmount = parseFloat(step.getAttribute("data-amount"));
								if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

								step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + "%";

								const productElem = step.querySelector(".product_or_discount");
								if (!productElem) return;

								const type = productElem.getAttribute("data-product-or-discount");
								const productVariantId = productElem.getAttribute("data-product-id");
								const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;

                                const productIdOnly = productElem.querySelector('.cart_free_product_wrapper')?.getAttribute("data-product-id");

                                // IF (cartPrice >= stepAmount)

                                if (cartPrice >= stepAmount && type === "product") {

                                    // Check ANY variant of the same product
                                    const hasFreeItem = cart.items.some(item => {
                                        return item.product_id.toString() === productIdOnly.toString() && Number(item.price) === 0;
                                    });

                                    const hasPaidItem = cart.items.some(item => {
                                        return item.product_id.toString() === productIdOnly.toString() && Number(item.price) > 0;
                                    });

                                    // If ANY variant exists → do NOT render
                                    const shouldRender = !hasFreeItem;

                                    if (shouldRender) {
                                        allProductsHTML += `
                                            <div class="single_step_product_wrapper" id="${wrapperId}">
                                                <div class="free_product_wrapper_inner">
                                                    ${productElem.innerHTML}
                                                </div>
                                            </div>`;
                                    }
                                }
                                else {
                                        // 1. Remove accordion HTML
                                        const mainAccordion = document.querySelector('.main_free_product_accordion_wrapper');
                                        if (mainAccordion) {
                                            const productWrapper = mainAccordion.querySelector(`#${wrapperId}`);
                                            if (productWrapper) productWrapper.remove();
                                        }
                                        // 2. Remove only free variant from cart
                                        if (type === "product") {
                                            const matchedItems = cart.items.filter(item => {
                                                return item.product_id.toString() === productIdOnly.toString();
                                            });
                                            matchedItems.forEach(item => {
                                                if (Number(item.price) === 0) {
                                                    removeProductFromCart(item.variant_id);
                                                } else {
                                                    // console.log("Keeping paid variant:", item.variant_id);
                                                }
                                            });
                                        }
                                    }

                            });

							let sidebarWrapper = document.querySelector('.sidebar__free_product_wrapper');

							let cartPageWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');

							if (!cartPageWrapper && document.body.classList.contains('template-cart')) {
								const cartItemsWrapper = document.querySelector('.cart-form__items');
								if (cartItemsWrapper) {
									cartPageWrapper = document.createElement('div');
									cartPageWrapper.classList.add('sidebar__free_product_wrapper');
									cartItemsWrapper.appendChild(cartPageWrapper);

										if (allProductsHTML.trim() !== '') {
											const wrapper = document.createElement('div');
											wrapper.classList.add('main_free_product_accordion_wrapper');
											wrapper.innerHTML = `
												<div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
													<span class="productTitleItg">Free Gift</span>
													<span class="svg-wrapper accordion_down_icon">
														<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
															<path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
														</svg>
													</span>
												</div>
												<div class="free_product_wrapper" style="display:block;">
													<div class="free_product_inner_container">
														${allProductsHTML}
													</div>
												</div>
											`;

											// Toggle accordion
											wrapper.querySelector('.headerItg').addEventListener('click', () => {
												const content = wrapper.querySelector('.free_product_wrapper');
												content.style.display = content.style.display === 'block' ? 'none' : 'block';
											});

											cartPageWrapper.appendChild(wrapper);
										} else {
											cartPageWrapper.classList.add('hideWrapper');
										}
									}
								}else{
									let sidebarWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');
									if (sidebarWrapper) {
										sidebarWrapper.innerHTML = '';
									}
								}       

							// CART DRAWER: clear previous content
							if (sidebarWrapper) {
								sidebarWrapper.innerHTML = '';
							}
						
							// Only build accordion if there are products
							if (allProductsHTML.trim() !== '') {
								const wrapper = document.createElement('div');
								wrapper.classList.add('main_free_product_accordion_wrapper');
								wrapper.innerHTML = `
									<div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
										<span class="productTitleItg">Free Gift</span>
										<span class="svg-wrapper accordion_down_icon">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
												<path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
											</svg>
										</span>
									</div>
									<div class="free_product_wrapper" style="display:block;">
										<div class="free_product_inner_container">
											${allProductsHTML}
										</div>
									</div>
								`;

								// Toggle accordion
								wrapper.querySelector('.headerItg').addEventListener('click', () => {
									const content = wrapper.querySelector('.free_product_wrapper');
									content.style.display = content.style.display === 'block' ? 'none' : 'block';
								});

								sidebarWrapper.appendChild(wrapper);
							} else {
								sidebarWrapper.classList.add('hideWrapper');
							}
						})();

						// Filled bar
						if (!isNaN(cartPrice)) {
							let filledPercent = ((cartPrice * 100) / maxAmountPrice);
							filledPercent = Math.min(Math.max(filledPercent, 0), 100);

							const filledBar = cartBar.querySelector(".cart_drawer_filled_bar");
							if (filledBar) {
								filledBar.style.width = filledPercent + "%";

							}
						}

						// subtotalAmt Updated

						// console.log(subTotalAmt);
						document.querySelector('.cart_drawer_progress_bar').setAttribute("data-cart-price" , subTotalAmt ) ;
						localStorage.setItem('loadedCartPrice', subTotalAmt);

					// removeProductFromCart  function //

					async function removeProductFromCart(productVariantId) {
						try {
							const lineItemElem = document.querySelector(`#item-${productVariantId}`);

							if (lineItemElem) {
								const removeBtn = lineItemElem.querySelector('a.remove, button.remove');

								if (removeBtn) {
									removeBtn.click(); // trigger click on the remove button
									// await updateCartDrawer() ;

								} else {
									console.warn(`Remove button not found for variant ${productVariantId}`);
								}
							} else {
								console.warn(`Line item not found in DOM for variant ${productVariantId}`);
							}
						} catch (err) {
							console.error(`Error removing variant ${productVariantId}:`, err);
						}
					}	
    }

    function updateCartQty(item, newQty){

        let alert = null;
        document.getElementById('AjaxCartForm').classList.add('processing');
        if ( document.getElementById('AjaxCartForm').querySelector('.alert') ) {
            document.getElementById('AjaxCartForm').querySelector('.alert').remove();
        }

        const body = JSON.stringify({
            line: parseInt(item.dataset.line),
            quantity: newQty
        });

        fetch(KROWN.settings.routes.cart_change_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
                body
            })
            .then(response => response.json())
            .then(response => {
                if ( response.status == 422 ) {
                    // wrong stock logic alert
                    alert = document.createElement('span');
                    alert.classList.add('alert', 'alert--error');
                    if ( typeof response.description === 'string' ) {
                        alert.innerHTML = response.description;
                    } else {
                        alert.innerHTML = response.message;
                    }
                }
                return fetch('?section_id=helper-cart');
            })
            .then(response => response.text())
            .then(text => {

                const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

                const cartItems = document.getElementById('AjaxCartForm');
                cartItems.innerHTML = cartFormInnerHTML;
                cartItems.ajaxifyCartItems();

                document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
                    elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
                });
                document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
                    elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
                });

                if ( alert !== null ) {	
                    document.getElementById('AjaxCartForm').prepend(alert);
                } 

                document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
                newUpdateCartDrawer() ;

                const event = new Event('cart-updated');
                document.getElementById('AjaxCartForm').dispatchEvent(event);

            })
            .catch(e => {
                console.log(e);
                let alert = document.createElement('span');
                alert.classList.add('alert', 'alert--error');
                alert.textContent = KROWN.settings.locales.cart_general_error;
                document.getElementById('AjaxCartForm').prepend(alert);
            })
            .finally(() => {
                document.getElementById('AjaxCartForm').classList.remove('processing');
            });
    }

    function ajaxifyCartItems(cartItemsContainer) {
        const form = cartItemsContainer.querySelector('form');

        cartItemsContainer.querySelectorAll('[data-js-cart-item]').forEach(item => {
            const remove = item.querySelector('.remove');
            if (remove) {       
                remove.dataset.href = remove.getAttribute('href');
                remove.setAttribute('href', '');
                remove.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.updateCartQty(item, 0); // Assuming you have updateCartQty defined elsewhere
  
                });
            }

        });
    }

    async function addProductToCart(productVariantId, quantity = 1) {
        try {

                const properties = {
                   _free_product: 0  
                };

                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: productVariantId,
                        quantity,
                        properties
                    })
                });

                await updateCartDrawer();
                await updateProgressBar(); 

                // updateCartContents({ showOverlay: true });

                fetch('?section_id=helper-cart')
                    .then((response) => response.text())
                    .then((text) => {

                        // console.log("inside modified fetch") ;
                        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                        const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                        const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

                        const cartItems = document.getElementById('AjaxCartForm');
                        cartItems.innerHTML = cartFormInnerHTML;
                        ajaxifyCartItems(cartItems);

                        document
                            .querySelectorAll('[data-header-cart-count]')
                            .forEach((element) => {
                                element.textContent = document.querySelector(
                                    '#AjaxCartForm [data-cart-count]'
                                ).textContent
                            })
                        document
                            .querySelectorAll('[data-header-cart-total]')
                            .forEach((element) => {
                                element.textContent = document.querySelector(
                                    '#AjaxCartForm [data-cart-total]'
                                ).textContent
                            })

                    })
                    .catch((error) => {
                        console.error('Error updating cart contents:', error)
                    })
            } catch (err) {
                console.error(`Error adding variant ${productVariantId}:`, err);
            }
        }


    async function updateCartDrawer() {
            // console.log("updateCartDrawer functions called") ;
            try {
                const response = await fetch('?section_id=helper-cart');
                const text = await response.text();

                const parser = new DOMParser();
                const doc = parser.parseFromString(text, 'text/html');

                const cartForm = doc.getElementById('AjaxCartForm').innerHTML;
                const cartSubtotal = doc.getElementById('AjaxCartSubtotal').innerHTML;

                document.getElementById('AjaxCartForm').innerHTML = cartForm;
                document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotal;

                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = cartSubtotal;

                const cartTotalElem = tempDiv.querySelector(".cart__total");
                const cartTotalNew = cartTotalElem ? cartTotalElem.getAttribute("data-total-price") : 0;

                // console.log(cartTotalNew);

                document.querySelector('.cart_drawer_progress_bar').setAttribute("data-cart-price" , cartTotalNew) ;
                localStorage.setItem('loadedCartPrice', cartTotalNew);

                const cartCount = doc.querySelector('#AjaxCartForm [data-cart-count]').textContent;
                document.querySelectorAll('[data-header-cart-count]').forEach(element => {
                    element.textContent = cartCount;
                });

                const cartTotal = doc.querySelector('#AjaxCartForm [data-cart-total]').textContent;
                document.querySelectorAll('[data-header-cart-total]').forEach(element => {
                    element.textContent = cartTotal;
                });

            } catch (error) {
                console.error('Error updating cart contents:', error);
            }
            setTimeout(()=>{
                newUpdateCartDrawer() ;
            },1000) ;
    }

    async function removeProductFromCart(productVariantId) {
        try {
            // Target the line item div by variantId
            const lineItemElem = document.querySelector(`#item-${productVariantId}`);

            if (lineItemElem) {
                // Find the remove button inside this line item
                const removeBtn = lineItemElem.querySelector('a.remove, button.remove');

                if (removeBtn) {
                    removeBtn.click(); // trigger click on the remove button
                    await updateCartDrawer() ;
                    await updateProgressBar() ;
                } else {
                    console.warn(`Remove button not found for variant ${productVariantId}`);
                }
            } else {
                console.warn(`Line item not found in DOM for variant ${productVariantId}`);
            }
        } catch (err) {
            console.error(`Error removing variant ${productVariantId}:`, err);
        }
    }

async function updateProgressBar() {

    const main_progress_wrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
    if (!main_progress_wrapper) return;

    const cartBar = main_progress_wrapper.querySelector(".cart_drawer_progress_bar");
    const maxAmountPrice = parseFloat(cartBar?.getAttribute("data-maxamt"));
    const cartPrice = parseFloat(cartBar?.getAttribute("data-cart-price"));

    if (isNaN(maxAmountPrice) || isNaN(cartPrice)) return;

    localStorage.setItem('loadedCartPrice', cartPrice);

    const allSteps = main_progress_wrapper.querySelectorAll(".progbar_counter");

    // Fetch current cart once
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    // Filled bar
    const filledBar = cartBar.querySelector(".cart_drawer_filled_bar");
    if (filledBar && maxAmountPrice > 0) {
        let filledPercent = ((cartPrice * 100) / maxAmountPrice);
        filledPercent = Math.min(Math.max(filledPercent, 0), 100);
        filledBar.style.width = filledPercent + "%";
    }

     let allProductsHTML = '';

    allSteps.forEach((step, index) => {
        const stepAmount = parseFloat(step.getAttribute("data-amount"));
        if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

        step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + "%";

        const productElem = step.querySelector(".product_or_discount");
        if (!productElem) return;

        const type = productElem.getAttribute("data-product-or-discount");
        const productVariantId = productElem.getAttribute("data-product-id");
        const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;
        const productIdOnly = productElem.querySelector('.cart_free_product_wrapper')?.getAttribute("data-product-id");
        // IF (cartPrice >= stepAmount)

        if (cartPrice >= stepAmount && type === "product") {

            // Check ANY variant of the same product
            const hasFreeItem = cart.items.some(item => {
                return item.product_id.toString() === productIdOnly.toString() && Number(item.price) === 0;
            });

            const hasPaidItem = cart.items.some(item => {
                return item.product_id.toString() === productIdOnly.toString() && Number(item.price) > 0;
            });

            // If ANY variant exists → do NOT render
            const shouldRender = !hasFreeItem;

            if (shouldRender) {
                allProductsHTML += `
                    <div class="single_step_product_wrapper" id="${wrapperId}">
                        <div class="free_product_wrapper_inner">
                            ${productElem.innerHTML}
                        </div>
                    </div>`;
            }
        }
        else {
                // 1. Remove accordion HTML
                const mainAccordion = document.querySelector('.main_free_product_accordion_wrapper');
                if (mainAccordion) {
                    const productWrapper = mainAccordion.querySelector(`#${wrapperId}`);
                    if (productWrapper) productWrapper.remove();
                }
                // 2. Remove only free variant from cart
                if (type === "product") {
                    const matchedItems = cart.items.filter(item => {
                        return item.product_id.toString() === productIdOnly.toString();
                    });
                    matchedItems.forEach(item => {
                        if (Number(item.price) === 0) {
                            removeProductFromCart(item.variant_id);
                        } else {
                            // console.log("Keeping paid variant:", item.variant_id);
                        }
                    });
                }
            }

        });

            let sidebarWrapper = document.querySelector('.sidebar__free_product_wrapper');
            let cartPageWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');

            if (!cartPageWrapper && document.body.classList.contains('template-cart')) {
                const cartItemsWrapper = document.querySelector('.cart-form__items');
                if (cartItemsWrapper) {
                    cartPageWrapper = document.createElement('div');
                    cartPageWrapper.classList.add('sidebar__free_product_wrapper');
                    cartItemsWrapper.appendChild(cartPageWrapper);

                        if (allProductsHTML.trim() !== '') {
                            const wrapper = document.createElement('div');
                            wrapper.classList.add('main_free_product_accordion_wrapper');
                            wrapper.innerHTML = `
                                <div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
                                    <span class="productTitleItg">Free Gift</span>
                                    <span class="svg-wrapper accordion_down_icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                            <path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
                                        </svg>
                                    </span>
                                </div>
                                <div class="free_product_wrapper" style="display:block;">
                                    <div class="free_product_inner_container">
                                        ${allProductsHTML}
                                    </div>
                                </div>
                            `;

                            // Toggle accordion
                            wrapper.querySelector('.headerItg').addEventListener('click', () => {
                                const content = wrapper.querySelector('.free_product_wrapper');
                                content.style.display = content.style.display === 'block' ? 'none' : 'block';
                            });

                            cartPageWrapper.appendChild(wrapper);
                        } else {
                            cartPageWrapper.classList.add('hideWrapper');
                        }
                    }
            }
            else{
                    let sidebarWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');
                    if (sidebarWrapper) {
                        sidebarWrapper.innerHTML = '';
                    }
            }

            // CART DRAWER: clear previous content
            if (sidebarWrapper) {
                sidebarWrapper.innerHTML = '';
            }

            // Only build accordion if there are products
            if (allProductsHTML.trim() !== '') {
                const wrapper = document.createElement('div');
                wrapper.classList.add('main_free_product_accordion_wrapper');
                wrapper.innerHTML = `
                    <div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
                        <span class="productTitleItg">Free Gift</span>
                        <span class="svg-wrapper accordion_down_icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                <path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
                            </svg>
                        </span>
                    </div>
                    <div class="free_product_wrapper" style="display:block;">
                        <div class="free_product_inner_container">
                            ${allProductsHTML}
                        </div>
                    </div>
                `;

                // Toggle accordion
                wrapper.querySelector('.headerItg').addEventListener('click', () => {
                    const content = wrapper.querySelector('.free_product_wrapper');
                    content.style.display = content.style.display === 'block' ? 'none' : 'block';
                });
                sidebarWrapper.appendChild(wrapper);
            } else {
                sidebarWrapper.classList.add('hideWrapper');
            }
}

// Cart Drawer Progress Bar js

// cart upsells services js

document.addEventListener("DOMContentLoaded", function() {

    let estimateShippingBtn = document.querySelector('.js-estimate-shipping');
    const cartWrapper = document.querySelector('#site-cart-sidebar .cart-form');
    const mainCartWrapper = document.querySelector('.template-cart .cart-section');

    const checkEligibilityInLocalStorage = () => {
        const eligibility = localStorage.getItem('eligibility');
        return eligibility?.toLowerCase() === 'true' ? true
            : eligibility?.toLowerCase() === 'false' ? false
            : null;
    };

    const toggleAssemblyInCart = (isEligible) => {

        if (cartWrapper) cartWrapper.classList.toggle('hide_assembly_variants', !isEligible);
        if (mainCartWrapper) mainCartWrapper.classList.toggle('hide_assembly_variants', !isEligible);

        // Get main wrappers (safely)
        const mainCartDrawerWrapper = cartWrapper?.querySelector(".cart__items");
        const mainCartPageWrapper = mainCartWrapper?.querySelector(".cart-form__items");

        let hasAssemblyMessage = false;

        // --- Process main cart page items ---
        if (mainCartPageWrapper) {
            const itemWrappers = mainCartPageWrapper.querySelectorAll('.cart-form-item');

            itemWrappers.forEach(wrapper => {
                const title = (wrapper.dataset.title || "").toLowerCase();

                if (title.includes("assembly services")) {
                    if (!isEligible) {
                        if (!wrapper.querySelector('.assembly-service-msg')) {
                            const msg = document.createElement('p');
                            msg.className = 'assembly-service-msg';
                            msg.textContent = "Assembly service isn’t offered in your selected location. To proceed with checkout, please remove this item from your cart.";
                            wrapper.appendChild(msg);
                        }
                        hasAssemblyMessage = true;
                    } else {
                        const existingMsg = wrapper.querySelector('.assembly-service-msg');
                        if (existingMsg) existingMsg.remove();
                    }
                }
            });
        }

        // --- Process cart drawer items ---
        if (mainCartDrawerWrapper) {
            const itemWrappers = mainCartDrawerWrapper.querySelectorAll('.itg_cart_item_wrapper');

            itemWrappers.forEach(wrapper => {
                const cartItem = wrapper.querySelector('.cart-item');
                if (!cartItem) return;

                const title = (cartItem.dataset.title || "").toLowerCase();

                if (title.includes("assembly services")) {
                    if (!isEligible) {
                        if (!wrapper.querySelector('.assembly-service-msg')) {
                            const msg = document.createElement('p');
                            msg.className = 'assembly-service-msg';
                            // msg.textContent = "It is no longer valid for the updated location";
                            msg.textContent = "Assembly service isn’t offered in your selected location. To proceed with checkout, please remove this item from your cart.";
                            wrapper.appendChild(msg);
                        }
                        hasAssemblyMessage = true;
                    } else {
                        const existingMsg = wrapper.querySelector('.assembly-service-msg');
                        if (existingMsg) existingMsg.remove();
                    }
                }
            });
        }

        // --- Disable all checkout buttons if needed ---
        const checkoutBtns = document.querySelectorAll('button#CheckOut');
        checkoutBtns.forEach(btn => {
            btn.disabled = hasAssemblyMessage;
            btn.style.opacity = hasAssemblyMessage ? 0.5 : 1;
            btn.style.pointerEvents = hasAssemblyMessage ? 'none' : 'auto';
        });
    };

    toggleAssemblyInCart(checkEligibilityInLocalStorage());

    function handleAddToCartClick(e) {
        const button = e.target.closest('.button.assembly-variant-form, .button.warranty-variant-form');
        if (!button) return;

        e.preventDefault();
        const variantId = button.querySelector('input[name="id"]').value;
        const data = {
            items: [
                { id: variantId, quantity: 1 }
            ]
        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(data => {

            // Run sequentially
            // updateCartContents({ showOverlay: true });

            updateCartDrawer();
            updateProgressBar(); 

            fetch('?section_id=helper-cart')
                .then((response) => response.text())
                .then((text) => {

                    const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                    const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                    const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

                    const cartItems = document.getElementById('AjaxCartForm');
                    cartItems.innerHTML = cartFormInnerHTML;
                    ajaxifyCartItems(cartItems);

                    document
                        .querySelectorAll('[data-header-cart-count]')
                        .forEach((element) => {
                            element.textContent = document.querySelector(
                                '#AjaxCartForm [data-cart-count]'
                            ).textContent
                        })
                    document
                        .querySelectorAll('[data-header-cart-total]')
                        .forEach((element) => {
                            element.textContent = document.querySelector(
                                '#AjaxCartForm [data-cart-total]'
                            ).textContent
                        })

                })
                .catch((error) => {
                    console.error('Error updating cart contents:', error)
                })


                updateCartProgress();

        })
        .catch(error => {
            console.error('Error adding to cart:', error);
        });

        function updateCartProgress(cartSubtotalId = 'AjaxCartSubtotal') {

            let storedCartPrice = parseFloat(localStorage.getItem('loadedCartPrice')) || 0;
						const subTotalElem = document.getElementById('AjaxCartSubtotal');
						if (!subTotalElem) return;

						let subTotalAmt = subTotalElem.querySelector('.cart__total')?.getAttribute("data-total-price");
						if (!subTotalAmt) return;		

						let cartPrice = parseFloat(subTotalAmt.replace(/,/g, '').trim());

						const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
						if (!mainProgressWrapper) return;

						const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
						if (!cartBar) return;

						const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
						if (isNaN(maxAmountPrice) || maxAmountPrice <= 0) return;

						const allSteps = mainProgressWrapper.querySelectorAll(".progbar_counter");

						(async () => {
							// Fetch current cart
							const cartResponse = await fetch('/cart.js');
							const cart = await cartResponse.json();

							let allProductsHTML = '';

							const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
							if (!mainProgressWrapper) return;

							const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
							if (!cartBar) return;

							const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
							const subTotalElem = document.getElementById('AjaxCartSubtotal')?.querySelector('.cart__total');
							const cartPrice = parseFloat(subTotalElem?.getAttribute("data-total-price")?.replace(/,/g, '').trim() || 0);

							const allSteps = mainProgressWrapper.querySelectorAll(".progbar_counter");
							if (!allSteps.length) return;

                            allSteps.forEach((step, index) => {
								const stepAmount = parseFloat(step.getAttribute("data-amount"));
								if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

								step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + "%";

								const productElem = step.querySelector(".product_or_discount");
								if (!productElem) return;

								const type = productElem.getAttribute("data-product-or-discount");
								const productVariantId = productElem.getAttribute("data-product-id");
								const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;

                                const productIdOnly = productElem.querySelector('.cart_free_product_wrapper')?.getAttribute("data-product-id");

                                // IF (cartPrice >= stepAmount)

                                if (cartPrice >= stepAmount && type === "product") {

                                    // Check ANY variant of the same product
                                    const hasFreeItem = cart.items.some(item => {
                                        return item.product_id.toString() === productIdOnly.toString() && Number(item.price) === 0;
                                    });

                                    const hasPaidItem = cart.items.some(item => {
                                        return item.product_id.toString() === productIdOnly.toString() && Number(item.price) > 0;
                                    });

                                    // If ANY variant exists → do NOT render
                                    const shouldRender = !hasFreeItem;
                                    if (shouldRender) {
                                        allProductsHTML += `
                                            <div class="single_step_product_wrapper" id="${wrapperId}">
                                                <div class="free_product_wrapper_inner">
                                                    ${productElem.innerHTML}
                                                </div>
                                            </div>`;
                                    }
                                }
                                else {
                                    // 1. Remove accordion HTML
                                    const mainAccordion = document.querySelector('.main_free_product_accordion_wrapper');
                                    if (mainAccordion) {
                                        const productWrapper = mainAccordion.querySelector(`#${wrapperId}`);
                                        if (productWrapper) productWrapper.remove();
                                    }
                                    // 2. Remove only free variant from cart
                                    if (type === "product") {
                                        const matchedItems = cart.items.filter(item => {
                                            return item.product_id.toString() === productIdOnly.toString();
                                        });

                                        matchedItems.forEach(item => {
                                            if (Number(item.price) === 0) {
                                                removeProductFromCart(item.variant_id);
                                            } else {
                                                // console.log("Keeping paid variant:", item.variant_id);
                                            }
                                        });
                                    }
                                }
                            });

							let sidebarWrapper = document.querySelector('.sidebar__free_product_wrapper');
							let cartPageWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');

							if (!cartPageWrapper && document.body.classList.contains('template-cart')) {
								const cartItemsWrapper = document.querySelector('.cart-form__items');
								if (cartItemsWrapper) {
									cartPageWrapper = document.createElement('div');
									cartPageWrapper.classList.add('sidebar__free_product_wrapper');
									cartItemsWrapper.appendChild(cartPageWrapper);

										if (allProductsHTML.trim() !== '') {
											const wrapper = document.createElement('div');
											wrapper.classList.add('main_free_product_accordion_wrapper');
											wrapper.innerHTML = `
												<div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
													<span class="productTitleItg">Free Gift</span>
													<span class="svg-wrapper accordion_down_icon">
														<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
															<path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
														</svg>
													</span>
												</div>
												<div class="free_product_wrapper" style="display:block;">
													<div class="free_product_inner_container">
														${allProductsHTML}
													</div>
												</div>
											`;

											// Toggle accordion
											wrapper.querySelector('.headerItg').addEventListener('click', () => {
												const content = wrapper.querySelector('.free_product_wrapper');
												content.style.display = content.style.display === 'block' ? 'none' : 'block';
											});
											cartPageWrapper.appendChild(wrapper);
										} else {
											cartPageWrapper.classList.add('hideWrapper');
										}
									
									}
								}else{
									let sidebarWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');
									if (sidebarWrapper) {
										sidebarWrapper.innerHTML = '';
									}
								}       

							// CART DRAWER: clear previous content
							if (sidebarWrapper) {
								sidebarWrapper.innerHTML = '';
							}
						
							// Only build accordion if there are products
							if (allProductsHTML.trim() !== '') {
								const wrapper = document.createElement('div');
								wrapper.classList.add('main_free_product_accordion_wrapper');
								wrapper.innerHTML = `
									<div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
										<span class="productTitleItg">Free Gift</span>
										<span class="svg-wrapper accordion_down_icon">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
												<path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
											</svg>
										</span>
									</div>
									<div class="free_product_wrapper" style="display:block;">
										<div class="free_product_inner_container">
											${allProductsHTML}
										</div>
									</div>
								`;

								// Toggle accordion
								wrapper.querySelector('.headerItg').addEventListener('click', () => {
									const content = wrapper.querySelector('.free_product_wrapper');
									content.style.display = content.style.display === 'block' ? 'none' : 'block';
								});

								sidebarWrapper.appendChild(wrapper);
							} else {
								sidebarWrapper.classList.add('hideWrapper');
							}
						})();

						// Filled bar
						if (!isNaN(cartPrice)) {
							let filledPercent = ((cartPrice * 100) / maxAmountPrice);
							filledPercent = Math.min(Math.max(filledPercent, 0), 100);
							const filledBar = cartBar.querySelector(".cart_drawer_filled_bar");
							if (filledBar) {
								filledBar.style.width = filledPercent + "%";
							}
						}
						// subtotalAmt Updated

						document.querySelector('.cart_drawer_progress_bar').setAttribute("data-cart-price" , subTotalAmt ) ;
						localStorage.setItem('loadedCartPrice', subTotalAmt);

					// removeProductFromCart  function //

					async function removeProductFromCart(productVariantId) {
						try {
							const lineItemElem = document.querySelector(`#item-${productVariantId}`);

							if (lineItemElem) {
								const removeBtn = lineItemElem.querySelector('a.remove, button.remove');
								if (removeBtn) {
									removeBtn.click(); // trigger click on the remove button
									// await updateCartDrawer() ;
								} else {
									console.warn(`Remove button not found for variant ${productVariantId}`);
								}
							} else {
								console.warn(`Line item not found in DOM for variant ${productVariantId}`);
							}
						} catch (err) {
							console.error(`Error removing variant ${productVariantId}:`, err);
						}
					}	

                    async function addProductToCart(productVariantId, quantity = 1) {
                            try {
                                await fetch('/cart/add.js', {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({ id: productVariantId, quantity })
                                });

                                fetch('?section_id=helper-cart')
                                    .then((response) => response.text())
                                    .then((text) => {

                                        // console.log("inside modified fetch") ;

                                        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                                        const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
                                        const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

                                        const cartItems = document.getElementById('AjaxCartForm');
                                        cartItems.innerHTML = cartFormInnerHTML;
                                        ajaxifyCartItems(cartItems);

                                        document
                                            .querySelectorAll('[data-header-cart-count]')
                                            .forEach((element) => {
                                                element.textContent = document.querySelector(
                                                    '#AjaxCartForm [data-cart-count]'
                                                ).textContent
                                            })
                                        document
                                            .querySelectorAll('[data-header-cart-total]')
                                            .forEach((element) => {
                                                element.textContent = document.querySelector(
                                                    '#AjaxCartForm [data-cart-total]'
                                                ).textContent
                                            })

                                    })
                                    .catch((error) => {
                                        console.error('Error updating cart contents:', error)
                                    })

                            } catch (err) {
                                console.error(`Error adding variant ${productVariantId}:`, err);
                            }
                    }
        }
    }
    // Event delegation: listen on document
    document.addEventListener('click', handleAddToCartClick);
});

// cart upsells services js

// Accordion toggle
				
// Event delegation for accordion headers inside sidebar__free_product_wrapper
document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('.sidebar__free_product_wrapper' );
    if (!wrapper) return;

    wrapper.addEventListener('click', (event) => {
        // Check if a headerItg was clicked
        const header = event.target.closest('.headerItg');
        if (!header || !wrapper.contains(header)) return;

        header.classList.toggle('active');

        // Toggle content visibility for this header
        const content = header.nextElementSibling; // free_product_wrapper
        if (content) {
            const isVisible = header.classList.contains('active');
            content.style.display = isVisible ? 'block' : 'none';
        }
    });
});

// Event delegation for accordion headers inside cart-section
document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('.cart-section');
    if (!wrapper) return;

    wrapper.addEventListener('click', (event) => {
        // Check if a headerItg was clicked
        const header = event.target.closest('.headerItg');
        if (!header || !wrapper.contains(header)) return;

        // Close all other headers in this wrapper
        const allHeaders = wrapper.querySelectorAll('.headerItg');
        allHeaders.forEach(h => {
            if (h !== header) {
                h.classList.remove('active');
                const otherContent = h.nextElementSibling; // content element
                if (otherContent) otherContent.style.display = 'none';
            }
        });

        // Toggle active class on clicked header
        header.classList.toggle('active');

        // Toggle content visibility for this header
        const content = header.nextElementSibling;
        if (content) {
            const isVisible = header.classList.contains('active');
            content.style.display = isVisible ? 'block' : 'none';
        }
    });
});

document.addEventListener('click', function (e) {
  const variant = e.target.closest('.itg_pro_variant_part');
  if (!variant) return;

  const productItem = variant.closest('.product-item');
  if (!productItem) return;

  const metaImg   = variant.getAttribute('data-metaimage');
  const metaTitle = variant.getAttribute('data-title');
  const metaHref  = variant.getAttribute('data-href');
  const metaProId = variant.getAttribute('data-pro_id');

  const mainImg = productItem.querySelector('.itg_card_promainimg img');
  if (mainImg && metaImg) {
    mainImg.src = metaImg;
    mainImg.srcset = metaImg;
  }

  // Title update
  if (metaTitle) {
    const titleSpan = productItem.querySelector('.product-item__title span');
    if (titleSpan) {
      titleSpan.textContent = metaTitle;
    }
  }

  // Price update
  const priceEl = variant.querySelector('.itg_meta_price_hide .product-price--original');
  if (priceEl) {
    const targetPrice = productItem.querySelector('.itg_price_ctmmmm');
    if (targetPrice) {
      targetPrice.innerHTML = priceEl.innerHTML;
    }
  }

  // Href update (title + image)
  if (metaHref) {
    const titleLink = productItem.querySelector('a.product-item__title');
    const imageLink = productItem.querySelector('a.product-item__image');
    if (titleLink) titleLink.href = metaHref;
    if (imageLink) imageLink.href = metaHref;
  }

  // Quick add product id update
  if (metaProId) {
    const quickAddLink = productItem.querySelector('.quick-add-to-cart a');
    if (quickAddLink) {
      quickAddLink.setAttribute('data-pro_id', metaProId);
      quickAddLink.setAttribute('data-id', metaProId);
      quickAddLink.setAttribute('href', metaHref);
    }
  }

  // Active class handling
  const allVariants = productItem.querySelectorAll('.itg_pro_variant_part');
  allVariants.forEach(function (el) {
    el.classList.remove('active');
  });

  variant.classList.add('active');
});

function updateCardFromVariant(scope) {
  const checkedInput = scope.querySelector('.itg_ctm_variant_option .product-variant__item input:checked');
  if (!checkedInput) return;

  const imgUrl = checkedInput.getAttribute('data-variant-image');
  const price = checkedInput.getAttribute('data-variant-price');

  // Image update
  if (imgUrl) {
    const mainImg = scope.querySelector('.itg_card_promainimg img');
    if (mainImg) {
      mainImg.src = imgUrl;
      mainImg.srcset = imgUrl;
    }
  }

  // Price update
  if (price) {
    const priceEl = scope.querySelector('.itg_price_ctmmmm');
    if (priceEl) {
      priceEl.innerHTML = price;
    }
  }
}
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-item').forEach(function(card) {
    updateCardFromVariant(card);

    // Variant change par update kare
    card.addEventListener('change', function(e) {
      if (e.target.matches('.itg_ctm_variant_option .product-variant__item input')) {
        updateCardFromVariant(card);
      }
    });
  });
});
